
<m-expansion-panel [id]="'dividasPendentes-dividasParceiros'" [title]="'Dívidas pendentes em parceiros ('+dividasParceiros.resultados.length+')'" [active]="larguraEhSuperiorMin">
  <div *ngIf="dividasParceiros.resultados.length > 0" class="table-responsive" id="div-table-dividasPendentes-dividasParceiros">
    <table id="id-table-dividasPendentes-dividasParceiros" class="table table-sm table-striped table-borderless" aria-label="Tabela de dívidas pendentes parceiros" style="font-size: smaller;">
      <thead>

      <tr>
        <th scope="col">Empresa</th>
        <th scope="col">CNPJ</th>
        <th scope="col">Contrato</th>
        <th scope="col">Data da ocorrência</th>
        <th scope="col">Data da inclusão</th>
        <th scope="col">Valor</th>


      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let divida of dividasParceiros.resultados; index as i">
          <td>{{ divida.empresa | naoinformado }}</td>
          <td>{{ divida.cnpj | naoinformado }}</td>
          <td>{{ divida.contrato | naoinformado }}</td>
          <td>{{ divida.dataOcorrencia | naoinformado }}</td>
          <td>{{ divida.dataInclusao | naoinformado }}</td>
          <td>{{ divida.valor | moedaReal }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div id="id-div-dividasPendentes-dividasParceiros-falha" *ngIf="listaServicoFalha.includes('bloco-divida-parceiros') || dividasParceiros.resultados.length == 0">
    {{dividasParceiros.falhaServico.message}}
  </div>

  <app-alert [id]="'dividasPendentes-parceiros-mensagem'" [tipo]="'info'" >
    A Serasa Experian e o SPC Brasil são entidades distintas, com bancos de dados próprios e podem utilizar nomenclaturas diferentes.
  </app-alert>

  <app-alert [id]="'dividasPendentes-parceiros-mensagem-2'" [tipo]="'info'" >
    Nos relatórios da Serasa a data da inclusão significa o momento em que o credor enviou pedido de negativação ao birô, a qual não se confunde com a data que a dívida foi disponibilizada para consulta no Cadastro de Inadimplentes.
  </app-alert>

</m-expansion-panel>

